export var MoveWarning;
(function (MoveWarning) {
    MoveWarning[MoveWarning["None"] = 0] = "None";
    MoveWarning[MoveWarning["CollaboratorMaybeEditing"] = 1] = "CollaboratorMaybeEditing";
    MoveWarning[MoveWarning["OwnerChange"] = 2] = "OwnerChange";
})(MoveWarning || (MoveWarning = {}));
export var CannotMoveReason;
(function (CannotMoveReason) {
    CannotMoveReason[CannotMoveReason["DifferentOwner"] = 1] = "DifferentOwner";
    CannotMoveReason[CannotMoveReason["PermissionDeniedDestination"] = 2] = "PermissionDeniedDestination";
    CannotMoveReason[CannotMoveReason["PermissionDeniedSource"] = 3] = "PermissionDeniedSource";
    CannotMoveReason[CannotMoveReason["NotAFolder"] = 4] = "NotAFolder";
    CannotMoveReason[CannotMoveReason["CrossBucketMoveDisabled"] = 5] = "CrossBucketMoveDisabled";
})(CannotMoveReason || (CannotMoveReason = {}));
